import Immutable from 'seamless-immutable';
import _ from 'lodash';
import WinnerModel from './winner-model';

function create(winners = []) {
  return Immutable(_.map(winners, WinnerModel.create));
}

function deserialize(winners = []) {
  return Immutable(_.map(winners, WinnerModel.deserialize));
}

export default {
  create,
  deserialize,
};
